import { proxy } from 'valtio';
import { Batch } from '../shared/VolunteerApplicationServiceTypes';

export const BatchInfoState = proxy<{
	batchInfo: Batch | undefined;
}>({
	batchInfo: undefined,
});
